import { PaymentServiceType } from '@dni-types/data-models/ecommerce-payment'
import { PAYMENT_ERROR_CODE, PaymentError } from './PaymentError'
import { type PaymentModule, type PaymentSetting } from './types'
import { isTappaySdkLoaded, loadTappayScript } from './utilities'

/**
 * @deprecated
 * Tappay LinePay 已經棄用，目前後端直接使用 linepay 的 API
 * 前端不用載入 SDK
 */
export class TappayLinePayModule implements PaymentModule<PaymentSetting> {
  isLoaded = false
  appEnv: PaymentSetting['appEnv'] = 'sandbox'
  appId: Required<PaymentSetting>['appId'] = ''
  appKey: Required<PaymentSetting>['appKey'] = ''

  public loadScript = () => loadTappayScript().then(() => {
    this.isLoaded = true
  })

  public configurePayment(details: PaymentSetting) {
    console.debug('[Tappay LinePay] configurePayment details:', details)
    if (!isTappaySdkLoaded(window.TPDirect)) return
    if (!details.appId || !details.appKey) {
      throw new PaymentError('[Tappay LinePay] appId or appKey is required', PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.INVALID_APP_ID_OR_APP_KEY)
    }

    this.appEnv = details.appEnv
    this.appId = details.appId
    this.appKey = details.appKey

    try {
      window.TPDirect.setupSDK(this.appId, this.appKey, this.appEnv)
    }
    catch (error) {
      throw new PaymentError(`[Tappay LinePay] Configuration failed: ${error}`, PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.CONFIGURATION_FAILED, error)
    }
  }

  public getPrime(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!isTappaySdkLoaded(window.TPDirect)) return
      try {
        window.TPDirect.linePay.getPrime((result) => {
          console.debug('[Tappay LinePay] getPrime result:', result)
          if (result.prime) {
            resolve(result.prime)
          }
          else {
            reject(new PaymentError('[Tappay LinePay] get prime failed', PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.INVALID_PRIME))
          }
        })
      }
      catch (error) {
        reject(new PaymentError(`[Tappay LinePay] Failed to get prime: ${error}`, PaymentServiceType.TAPPAY, PAYMENT_ERROR_CODE.GET_PRIME_ERROR, error))
      }
    })
  }
}
